import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Seo } from "@/lib/seo";
import { PageHero } from "@/components/page-hero";
import { Reveal } from "@/lib/motion";
import { MOMENTOS } from "@/content/moments";

export default function Momentos() {
  return (
    <>
      <Seo
        title="Momentos de vida"
        description="Identifica tu asunto legal por lo que está pasando en tu vida: casa, pareja, hijos, trabajo, patrimonio, cuidados y legado."
        path="/momentos"
      />
      <PageHero
        eyebrow="Explora por momento de vida"
        titulo="El derecho entra a tu vida por donde menos lo esperas"
        lead="Ocho momentos que concentran la mayoría de los asuntos que nos llevan las personas y las familias. Encuentra el tuyo y verás qué servicio aplica, qué documentos preparan y cómo seguir."
      />
      <section className="bg-parchment">
        <div className="mx-auto max-w-7xl px-4 py-16 sm:px-8 sm:py-24">
          <div>
            {MOMENTOS.map((m, i) => (
              <Reveal key={m.slug} delay={Math.min(i * 0.04, 0.2)} y={16}>
                <Link
                  to={`/momentos/${m.slug}`}
                  data-testid={`momentos-link-${m.slug}`}
                  className="group flex items-baseline gap-5 border-t border-hairline py-7 transition-colors duration-300 last:border-b hover:bg-parchment-surface/70 sm:items-center sm:gap-10 sm:px-4"
                >
                  <span className="font-mono text-xs text-azul">{String(i + 1).padStart(2, "0")}</span>
                  <span className="flex-1">
                    <span className="block font-serif text-2xl text-ink-deep transition-transform duration-300 group-hover:translate-x-1 sm:text-4xl">
                      {m.nombre}
                    </span>
                    <span className="mt-1.5 block max-w-xl text-sm text-ink-muted sm:text-base">{m.frase}</span>
                  </span>
                  <span className="hidden max-w-xs flex-1 text-sm text-ink-muted md:block">{m.situaciones[0]}</span>
                  <ArrowRight className="h-5 w-5 shrink-0 self-center text-ink-muted transition-all duration-300 group-hover:translate-x-1 group-hover:text-azul" />
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
